/* Scent panel — snippets/scent-panel.liquid
   Shows the selected variant's scent blurb + character-scale, updating as the
   shopper switches variants. Data is embedded server-side (variant metafields
   with a block-JSON fallback); this script only reads the current selection
   and repaints. Single-option "scent" products are matched by variant title. */
(function () {
  'use strict';

  if (customElements.get('scent-panel')) return;

  class ScentPanel extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('[data-scent-card]');
      const variants = this.readJSON('[data-scent-variants]') || {};
      const fallback = this.readJSON('[data-scent-fallback]') || {};

      /* Resolve each variant to {title, blurb, scale}, filling gaps from the
         title-keyed fallback. Keyed by lowercased title for lookup. */
      this.byTitle = {};
      Object.keys(variants).forEach((id) => {
        const v = variants[id];
        const key = String(v.title || '').toLowerCase().trim();
        const fb = fallback[key] || {};
        const blurb = v.blurb && v.blurb.length ? v.blurb : fb.blurb || '';
        const scale = v.scale && Object.keys(v.scale).length ? v.scale : fb.scale || null;
        this.byTitle[key] = { title: v.title, blurb: blurb, scale: scale };
      });

      this.scope =
        this.closest('product-info') ||
        this.closest('.product__info-container') ||
        this.closest('[id^="ProductInfo"]') ||
        document;

      this.render(this.currentTitle());

      this.onChange = this.onChange.bind(this);
      this.scope.addEventListener('change', this.onChange);

      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.optionValueSelectionChange) {
        this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, () => {
          window.setTimeout(() => this.render(this.currentTitle()), 0);
        });
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.scope) this.scope.removeEventListener('change', this.onChange);
    }

    readJSON(selector) {
      const el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    currentTitle() {
      const picker =
        (this.scope.querySelector && this.scope.querySelector('variant-selects')) ||
        document.querySelector('variant-selects');
      if (picker) {
        const checked = picker.querySelector('input:checked');
        if (checked && checked.value) return String(checked.value).toLowerCase().trim();
        const select = picker.querySelector('select');
        if (select && select.value) return String(select.value).toLowerCase().trim();
      }
      const keys = Object.keys(this.byTitle);
      return keys.length ? keys[0] : null;
    }

    onChange(event) {
      const target = event.target;
      if (target && (target.name || (target.closest && target.closest('variant-selects')))) {
        window.setTimeout(() => this.render(this.currentTitle()), 0);
      }
    }

    render(titleKey) {
      const data = titleKey && this.byTitle[titleKey];
      if (!data || (!data.blurb && !data.scale)) {
        if (this.card) this.card.hidden = true;
        return;
      }

      const nameEl = this.querySelector('[data-scent-name]');
      if (nameEl) nameEl.textContent = data.title || '';

      const blurbEl = this.querySelector('[data-scent-blurb]');
      if (blurbEl) blurbEl.textContent = data.blurb || '';

      const scalesEl = this.querySelector('[data-scent-scales]');
      if (scalesEl) {
        scalesEl.textContent = '';
        const scale = data.scale || {};
        Object.keys(scale).forEach((axis) => {
          const value = Math.max(0, Math.min(100, Number(scale[axis]) || 0));
          const parts = String(axis).split('|');
          const left = (parts[0] || '').trim();
          const right = (parts[1] || '').trim();

          const row = document.createElement('div');
          row.className = 'scent-panel__scale';

          const leftLabel = document.createElement('span');
          leftLabel.className = 'scent-panel__scale-label';
          leftLabel.textContent = left;

          const track = document.createElement('span');
          track.className = 'scent-panel__scale-track';
          const marker = document.createElement('span');
          marker.className = 'scent-panel__scale-marker';
          marker.style.left = value + '%';
          track.appendChild(marker);

          const rightLabel = document.createElement('span');
          rightLabel.className = 'scent-panel__scale-label scent-panel__scale-label--right';
          rightLabel.textContent = right;

          row.appendChild(leftLabel);
          row.appendChild(track);
          row.appendChild(rightLabel);
          scalesEl.appendChild(row);
        });
      }

      if (this.card) this.card.hidden = false;
    }
  }

  customElements.define('scent-panel', ScentPanel);
})();
